import React from 'react';

export const PropertyCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden animate-pulse">
      {/* Image Skeleton */}
      <div className="relative aspect-[4/3]">
        <div className="absolute inset-0 bg-gray-200"></div>
      </div>

      {/* Content Skeleton */}
      <div className="p-6">
        {/* Category Skeleton */}
        <div className="flex items-center mb-2">
          <div className="w-3 h-3 rounded-full mr-2 bg-gray-200"></div>
          <div className="w-24 h-4 bg-gray-200 rounded"></div>
        </div>

        {/* Title Skeleton */}
        <div className="h-6 bg-gray-200 rounded mb-2 w-3/4"></div>

        {/* Location Skeleton */}
        <div className="flex items-center mb-4">
          <div className="w-4 h-4 mr-1 bg-gray-200 rounded"></div>
          <div className="w-full h-4 bg-gray-200 rounded"></div>
        </div>

        {/* Property Details Skeleton */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <div className="flex items-center">
              <div className="w-4 h-4 mr-1 bg-gray-200 rounded"></div>
              <div className="w-6 h-4 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 mr-1 bg-gray-200 rounded"></div>
              <div className="w-6 h-4 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 mr-1 bg-gray-200 rounded"></div>
              <div className="w-16 h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* Description Skeleton */}
        <div className="space-y-2 mb-4">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>

        {/* Footer Skeleton */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <div className="flex items-center">
            <div className="w-4 h-4 mr-1 bg-gray-200 rounded"></div>
            <div className="w-16 h-4 bg-gray-200 rounded"></div>
          </div>
          <div className="w-24 h-8 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};